import React from 'react'
import SearchCars from "../components/SearchCars";
import { Helmet } from 'react-helmet';

function OilFilters() {

  const pageTitle = "Филтри за масло - Пребарување на автомобилски филтри за масло | Filter za maslo za tvojot avtomobil | Filter za ulje";
  const pageDescription = "Пронајди филтри за масло за твоето возило. Погледни ги различните опции за филтри за уље за твојот автомобили и диши чист воздух. Filtri za maslo.";
  const pageKeywords = "филтри за масло, филтри за уље, филтри за автомобили, авто филтри, филтри за масло за автомобил, автомобилски делови, моторни филтри";


  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={pageKeywords} />
      </Helmet>

      <div className='flex flex-col justify-start items-center'>
        <div>
          <h1 className='text-4xl font-bold mb-8'>Филтри за масло</h1>
        </div>
        <SearchCars category={2} allFilters={false} />
      </div>
    </>
  )
}

export default OilFilters
